import  { useContext, useEffect, useMemo, useState } from 'react';
import { handleStorage, translate } from '../../../utils/Common';
import Select from 'react-select';
import ThemeContext from '../../../contexts/theme';
import { getReactSelectStyles } from '../../../utils/reactSelectThemeStyles';
import { AiOutlineUser, AiOutlineUserAdd } from 'react-icons/ai';
import { useIncidents } from '../../../hooks/useIncidents';

const SESSION_KEY = 'users-support';

const AssignedUserSelect = ({
    assignedUserId,
    register, 
    errors,
    readOnly = false,
    onChange = () => {}
}) => {
    const {getAssignedUsersSupport} = useIncidents();
    
    const [assignedUsers, setAssignedUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const themeContext = useContext(ThemeContext);
    const theme = themeContext?.theme || 'light';
    // It carried no styles at all, so it kept react-select's white control and
    // near-black text in dark mode.
    const selectStyles = useMemo(() => getReactSelectStyles(theme), [theme]);
    const [selectedOption, setSelectedOption] = useState(null);

useEffect(() => {
        const abortController = new AbortController();

        const fetchUsers = async () => {
            try {
                let options = handleStorage('get', 'session', SESSION_KEY);

                if (!options || !Array.isArray(options)) {
                    const response = await getAssignedUsersSupport(abortController.signal);
                    options = response.map(user => ({
                        value: user.id,
                        label: user.name
                    }));
                    handleStorage('set', 'session', SESSION_KEY, options);
                }

                setAssignedUsers(options);

                const currentUser = options.find(user => user.value === assignedUserId);
                if (currentUser) setSelectedOption(currentUser);
            } catch (error) {
                console.error("Error al cargar usuarios asignables:", error);
            } finally {
                // Only the live request clears the flag: under StrictMode the effect
                // runs, aborts and runs again, and the discarded one used to switch
                // the indicator off for its replacement.
                if (!abortController.signal.aborted) setLoading(false);
            }
        };

        fetchUsers();
        return () => abortController.abort();
    }, [assignedUserId]);

    const handleChange = (option) => {
        setSelectedOption(option);

        // Notificar al componente padre si hay onChange
        if (onChange) {
            onChange(option?.value); // pasa el ID del usuario
        }
    };

    return (
        <div >
            <Select
                options={assignedUsers}
                value={selectedOption}
                onChange={handleChange}
                isDisabled={readOnly}
                name="assignedUser"
                placeholder={translate("global.select")}
                isSearchable
                classNamePrefix="react-select"
                className="react-select-container"
                isLoading={loading}
                styles={selectStyles}
            />

            {/* Register con react-hook-form manualmente */}
            <input
                type="hidden"
                name="assignedUser"
                ref={register({
                    required: translate("global.chooseUser")
                })}
                value={selectedOption?.value || ''}
            />

            {errors?.assignedUser && (
                <small className="text-error">{errors.assignedUser.message}</small>
            )}
        </div>
    );
};

export default AssignedUserSelect;